<script>
	import { currentLevel } from '../../stores/current-level';
	import { TemplateKeyword } from '../../utils/template-keyword';
	import { TemplateCodeBlock } from '../../utils/template-code-block';
	import { urlFragment } from '../../stores/url-fragment';
	import Template from '../elements/Template.svelte';
	import Icon from '../elements/Icon.svelte';

	const tags = {
		'keyword': new TemplateKeyword(),
		'code-block': new TemplateCodeBlock(),
	};
</script>

<div class="level-info">
	<h1>
		{ $currentLevel.title }
	</h1>

	<p class="goal">
		<b>Goal:</b> <Template template={ $currentLevel.goal } { tags } />
	</p>

	<hr />

	<p class="help-text">
		<Template template={ $currentLevel.helpText } { tags } />
	</p>

	<hr />

	<button class="large low-focus" on:click={ () => urlFragment.setUrlKey( 'menu', 'levelSelect' ) }>
		<Icon i="list" />
		Level Select
	</button>

	<button style="float: right;" class="large" on:click={ () => urlFragment.setUrlKey( 'tab', 'none' ) }>
		<Icon i="angle-double-right" />
		Get to it!
	</button>
</div>

<style>
	.level-info :global( .keyword ) {
		text-shadow: 1px 1px black;
		font-weight: bold;
	}

	.level-info :global( .keyword-robot ) {
		color: #ff5c33;
	}

	.level-info :global( .keyword-goal ) {
		color: #66ff33
	}

	.level-info :global( .keyword-conveyor ) {
		color: #00B2FF;
	}

	.level-info :global( .keyword-food ) {
		color: rgb(255, 251, 0);
	}

	.level-info :global( code ) {
		font-family: "Monaco", "Menlo", "Ubuntu Mono", "Consolas", "source-code-pro", monospace;
		font-size: 16px;
		padding-left: 5px;
		padding-right: 5px;
		background-color: rgba( 0, 0, 0, 0.3 );
	}
</style>
